module.exports = __webpack_public_path__ + "static/media/toolkitforuserinnovation.ef69085e.pdf";